package com.eladfinish.bible.contest.logging

// Compose's message for LeftCompositionCancellationException (the class name itself is mangled
// in production bundles, e.g. "ku: The coroutine scope left the composition", so match the
// message rather than the name).
private const val LEFT_COMPOSITION_MESSAGE = "The coroutine scope left the composition"

/**
 * Drops one known-benign console.error line: moko-resources' JS `painterResource(ImageResource)`
 * loads the image bytes in a `produceState { try { fetchByteArray(url) } catch (e: Exception) {
 * e.printStackTrace() } }` (resources-compose `produceByteArray.kt`, still the case in 0.27.1).
 * That catch also swallows the CancellationException thrown when the composable leaves
 * composition before its fetch completes, and Kotlin/JS `printStackTrace()` writes it with
 * console.error. It's just a cancelled fetch — nothing breaks — but it shows up as an error on
 * every page load restored straight into an inner screen (e.g. `#search?q=…`): the root menu's
 * SVG icons start fetching, then the root screen is replaced before they finish.
 *
 * Everything else, including other cancellation messages, still reaches the console.
 */
fun suppressBenignConsoleErrors() {
    val isBenign: (Any?) -> Boolean = { first ->
        first is String && first.substringBefore('\n').endsWith(": $LEFT_COMPOSITION_MESSAGE")
    }
    // Plain JS so the wrapper stays variadic and forwards every argument unchanged.
    js(
        """
        (function (isBenign) {
            var originalError = console.error;
            console.error = function () {
                if (arguments.length > 0 && isBenign(arguments[0])) return;
                return originalError.apply(console, arguments);
            };
        })
        """,
    )(isBenign)
}
